/*! gt-pdp-v2-vv.js - Goldtop PDP v2, 25 Sep 2026.

    KEEPS THE MOBILE BUY BAR ON THE BOTTOM EDGE OF THE SCREEN.

    Charlie, 25 Sep, Chrome on iOS: with the browser's own buttons showing, the
    bar sits just above them, as it should. Scroll, the buttons hide, and the
    bar stays where it was, with page showing through underneath it.

    The bar is position: fixed; bottom: 0 (gt-pdp-v2.css). iOS browsers do not
    always move a fixed element when their toolbars collapse; Slide Cart's
    drawer had the same fault on iOS Safari and theme.liquid fixes it the same
    way this does, from window.visualViewport, the one measure that always
    reflects what is actually on screen.

    WHAT THIS DOES. After scrolls and resizes it measures the bar's bottom edge
    against the bottom of the visual viewport. If the bar sits ABOVE it, the
    bar is moved down by the difference, with an inline bottom. It never moves
    the bar UP, so an open keyboard or a pinch-zoom behaves exactly as before.
    Where the browser already places the bar correctly (iOS Safari, Android)
    the gap is zero and nothing is written.

    Mobile only: does nothing unless html.gt-v2 is set, which the controller
    sets below 769px. A tucked bar (is-tucked) is left alone until it comes
    back. No dependency on the controller's internals.
*/
(function () {
  var vv = window.visualViewport;
  if (!vv || window.__gtVV) return;
  window.__gtVV = true;
  var HTML = document.documentElement;
  var raf = 0, bar = null, ro = null;

  function clear(b) {
    if (b.style.getPropertyValue("bottom")) b.style.removeProperty("bottom");
  }

  function place() {
    raf = 0;
    var b = document.querySelector(".gt-bar2");
    if (b !== bar) {
      bar = b;
      if (ro) { try { ro.disconnect(); } catch (e) {} ro = null; }
      if (b && window.ResizeObserver) { ro = new ResizeObserver(queue); ro.observe(b); }
    }
    if (!b) return;
    if (!HTML.classList.contains("gt-v2")) { clear(b); return; }
    if (b.classList.contains("is-tucked")) return;
    var cur = parseFloat(b.style.getPropertyValue("bottom")) || 0;
    var natural = b.getBoundingClientRect().bottom + cur;
    var shift = Math.round(vv.offsetTop + vv.height - natural);
    if (shift > 1) b.style.setProperty("bottom", (-shift) + "px", "important");
    else clear(b);
  }

  function queue() { if (!raf) raf = requestAnimationFrame(place); }

  vv.addEventListener("resize", queue);
  vv.addEventListener("scroll", queue);
  window.addEventListener("scroll", queue, { passive: true });
  window.addEventListener("resize", queue);
  window.addEventListener("orientationchange", function () { setTimeout(queue, 300); });
  window.addEventListener("touchend", function () { setTimeout(queue, 350); }, { passive: true });
  [0, 600, 1500, 3500, 6500].forEach(function (t) { setTimeout(queue, t); });
})();
